import { updateObject } from "../_utils";
import matchesConstants from "../_constants/matchesConstants";
import { concat } from "lodash";
import userConstants from "../_constants/userConstants";

const initialState = {
  recentlyViewed: [],
  liked: [],
  saved: [],
  shortlisted: [],
  expressedInterest: [],
  favorite: [],
  visitors: [],
  pendingInvitations: [],
  acceptInvitations: [],
  likedMe: [],
  interestedInMe: [],
  connected: [],
  lastResult: null,
  members: {}
};

const recentlyViewedMembers = (state, action) => {
  return updateObject(state, { recentlyViewed: action.payload });
};
const clearRecentlyViewedMembers = (state, action) => {
  return updateObject(state, { recentlyViewed: [] });
};
const getMatchedMemberProfile = (state, action) => {
  return updateObject(state, {
    members: updateObject(state.members, {
      [action.payload.id]: action.payload
    })
  });
};
const clearMatchedMembers = (state, action) => {
  return updateObject(state, {
    members: {}
  });
};
const getLikedMembers = (state, action) => {
  return updateObject(state, { liked: action.payload });
};
const clearLikedMembers = (state, action) => {
  return updateObject(state, { liked: [] });
};
const getSavedMembers = (state, action) => {
  return updateObject(state, { saved: action.payload });
};
const clearSavedMembers = (state, action) => {
  return updateObject(state, { saved: [] });
};
const getShortlistedMembers = (state, action) => {
  return updateObject(state, { shortlisted: action.payload });
};
const clearShortlistedMembers = (state, action) => {
  return updateObject(state, { shortlisted: [] });
};
const getExpressedInterestMembers = (state, action) => {
  return updateObject(state, { expressedInterest: action.payload });
};
const clearExpressedInterestMembers = (state, action) => {
  return updateObject(state, { expressedInterest: [] });
};
const getFavoriteMembers = (state, action) => {
  return updateObject(state, { favorite: action.payload });
};
const clearFavoriteMembers = (state, action) => {
  return updateObject(state, { favorite: [] });
};
const getProfileVisitors = (state, action) => {
  return updateObject(state, { visitors: action.payload });
};
const clearProfileVisitors = (state, action) => {
  return updateObject(state, { visitors: [] });
};
const getPendingInvitations = (state, action) => {
  return updateObject(state, { pendingInvitations: action.payload });
};
const clearPendingInvitations = (state, action) => {
  return updateObject(state, { pendingInvitations: [] });
};
const getAcceptInvitations = (state, action) => {
  return updateObject(state, { acceptInvitations: action.payload });
};
const clearAcceptInvitations = (state, action) => {
  return updateObject(state, { acceptInvitations: [] });
};
const getPeopleWhoLikedMe = (state, action) => {
  return updateObject(state, { likedMe: action.payload });
};
const clearPeopleWhoLikedMe = (state, action) => {
  return updateObject(state, { likedMe: [] });
};
const getPeopleExpressedInterestInMe = (state, action) => {
  return updateObject(state, { interestedInMe: action.payload });
};
const clearPeopleExpressedInterestInMe = (state, action) => {
  return updateObject(state, { interestedInMe: [] });
};
const getConnectedMembers = (state, action) => {
  return updateObject(state, { connected: action.payload });
};
const clearConnectedMembers = (state, action) => {
  return updateObject(state, { connected: [] });
};
const changeLastResultForMatches = (state, action) => {
  return updateObject(state, { lastResult: action.payload });
};
const loadMoreMatchResults = (state, action) => {
  const { stateRef, results } = action.payload;
  if (!stateRef) {
    return state;
  }
  return updateObject(state, {
    [stateRef]: concat(state[stateRef], results)
  });
};
/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case matchesConstants.RECENTLY_VIEWED_MEMBERS:
      return recentlyViewedMembers(state, action);
    case matchesConstants.CLEAR_RECENTLY_VIEWED_MEMBERS:
      return clearRecentlyViewedMembers(state, action);
    case matchesConstants.GET_MATCHED_MEMBER_PROFILE:
      return getMatchedMemberProfile(state, action);
    case matchesConstants.CLEAR_MATCHED_MEMBERS:
      return clearMatchedMembers(state, action);
    case matchesConstants.GET_LIKED_MEMBERS:
      return getLikedMembers(state, action);
    case matchesConstants.CLEAR_LIKED_MEMBERS:
      return clearLikedMembers(state, action);
    case matchesConstants.GET_SAVED_MEMBERS:
      return getSavedMembers(state, action);
    case matchesConstants.CLEAR_SAVED_MEMBERS:
      return clearSavedMembers(state, action);
    case matchesConstants.GET_SHORTLISTED_MEMBERS:
      return getShortlistedMembers(state, action);
    case matchesConstants.CLEAR_SHORTLISTED_MEMBERS:
      return clearShortlistedMembers(state, action);
    case matchesConstants.GET_EXPRESSED_INTEREST_MEMBERS:
      return getExpressedInterestMembers(state, action);
    case matchesConstants.CLEAR_EXPRESSED_INTEREST_MEMBERS:
      return clearExpressedInterestMembers(state, action);
    case matchesConstants.GET_FAVORITE_MEMBERS:
      return getFavoriteMembers(state, action);
    case matchesConstants.CLEAR_FAVORITE_MEMBERS:
      return clearFavoriteMembers(state, action);
    case matchesConstants.GET_PROFILE_VISITORS:
      return getProfileVisitors(state, action);
    case matchesConstants.CLEAR_PROFILE_VISITORS:
      return clearProfileVisitors(state, action);
    case matchesConstants.GET_PENDING_INVITATIONS:
      return getPendingInvitations(state, action);
    case matchesConstants.CLEAR_PENDING_INVITATIONS:
      return clearPendingInvitations(state, action);
    case matchesConstants.GET_ACCEPT_INVITATIONS:
      return getAcceptInvitations(state, action);
    case matchesConstants.CLEAR_ACCEPT_INVITATIONS:
      return clearAcceptInvitations(state, action);
    case matchesConstants.GET_PEOPLE_WHO_LIKED_ME:
      return getPeopleWhoLikedMe(state, action);
    case matchesConstants.CLEAR_PEOPLE_WHO_LIKED_ME:
      return clearPeopleWhoLikedMe(state, action);
    case matchesConstants.GET_PEOPLE_EXPRESSED_INTEREST_IN_ME:
      return getPeopleExpressedInterestInMe(state, action);
    case matchesConstants.CLEAR_PEOPLE_EXPRESSED_INTEREST_IN_ME:
      return clearPeopleExpressedInterestInMe(state, action);
    case matchesConstants.GET_CONNECTED_MEMBERS:
      return getConnectedMembers(state, action);
    case matchesConstants.CLEAR_CONNECTED_MEMBERS:
      return clearConnectedMembers(state, action);
    case matchesConstants.CHANGE_LAST_RESULT_FOR_MATCHES:
      return changeLastResultForMatches(state, action);
    case matchesConstants.LOAD_MORE_MATCH_RESULTS:
      return loadMoreMatchResults(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/matchesReducer.js